export default __webpack_public_path__ + "static/manage-474e1174cd4d73be729ae1ee9e9ecfa2.png";